import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { lzSortByPosition } from '../../services/LzUtils';

/**
 * LzCrudModelListActionIcon class
 */
export default class LzCrudModelListActionIcon {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.route = model.route ? model.route : '';
        this.routeTarget = model.routeTarget ? model.routeTarget : '_self';
        this.title = model.title ? model.title : '';
        this.getTitle = model.getTitle ? model.getTitle : (rec) => this.title;
        this.icon = model.icon ? model.icon : '';
        this.getIcon = model.getIcon ? model.getIcon : (rec) => this.icon;
        this.color = model.color ? model.color : '';
        this.getColor = model.getColor ? model.getColor : (rec) => this.color;
        this.hideOnDeleted = !!model.hideOnDeleted;
        this.showOnDeletedOnly = !!model.showOnDeletedOnly;
        this.showOnlyEvaluator = model.showOnlyEvaluator;
        this.sortOrder = model.sortOrder ? +model.sortOrder : 0;
    }

    static parseData(data, crud) {
        const out = {};

        if (!data) {
            data = {};
        }

        const keys = Object.keys(data);
        for (const key of keys) {
            out[key] = new LzCrudModelListActionIcon(data[key]);
        }

        // Now add based on crud settings
        if (crud.isTreeBased && crud.showTreeAdd && !out.add) {
            out.add = new LzCrudModelListActionIcon({ route: '{baseRoute}/add/{recordId}', title: 'Add Child', icon: <AddOutlinedIcon />, color: 'info', sortOrder: 5 });
        }
        if (crud.showView && !out.view) {
            out.view = new LzCrudModelListActionIcon({ route: '{baseRoute}/view/{recordId}', title: 'View', icon: <VisibilityIcon />, color: 'info', sortOrder: 10 });
        }
        if (crud.showEdit && !out.edit) {
            out.edit = new LzCrudModelListActionIcon({ route: '{baseRoute}/edit/{recordId}', title: 'Edit', icon: <EditIcon />, color: 'secondary', hideOnDeleted: true, sortOrder: 20 });
        }
        if (crud.showStatus && !out.status) {
            out.status = new LzCrudModelListActionIcon({
                getTitle: (rec) => rec.is_active ? 'Active' : 'In-Active',
                getIcon: (rec) => rec.is_active ? <CheckIcon /> : <CloseIcon />,
                getColor: (rec) => rec.is_active ? 'success' : 'warning',
                hideOnDeleted: true,
                sortOrder: 30
            });
        }
        if (crud.showDelete && !out.delete) {
            out.delete = new LzCrudModelListActionIcon({ title: 'Delete', icon: <DeleteIcon />, color: 'danger', hideOnDeleted: true, sortOrder: 40 });
        }
        if (crud.allowDeletedRestore && !out.deleted_restore) {
            out.deleted_restore = new LzCrudModelListActionIcon({ title: 'Restore', icon: <RestoreFromTrashIcon />, color: 'success', showOnDeletedOnly: true, sortOrder: 50 });
        }
        if (crud.allowDeletedPurge && !out.deleted_purge) {
            out.deleted_purge = new LzCrudModelListActionIcon({ title: 'Delete Forever', icon: <DeleteForeverIcon />, color: 'danger', showOnDeletedOnly: true, sortOrder: 60 });
        }

        // Sort by sort order and return
        return lzSortByPosition(out, 'sortOrder');
    }

}
